import { PluginCreator } from "tailwindcss/types/config"
import { getHex } from "./colors"

/* This plugin creates utility classes for SVG elements to handle hover states, etc */
export const svgPlugin: PluginCreator = ({ addUtilities }: { addUtilities: Function }) => {
  const fg1 = getHex("fg-1")

  const newUtilities = {
    ".stroke-black-hover": {
      stroke: fg1,
    },
    ".stroke-black-hover:hover": {
      stroke: fg1,
    },
    ".stroke-white": {
      stroke: fg1,
    },
    ".transition-stroke": {
      transition: "all 250ms ease-in-out",
    },
  }

  addUtilities(newUtilities, ["responsive", "hover"])
}
